<template>
  <div>
    <!-- <tab></tab> -->
    <router-view></router-view>
    <!-- <footerBar></footerBar> -->
  </div>
</template>

<script>
import tab from '@/components/tab'
import footerBar from '@/components/footerBar'
import axios from 'axios'
import { chunkArr } from '@/utils/util'
export default {
  name: 'activity',
  components: {
    tab:tab,
    footerBar:footerBar
  },
  data () {
    return {
      
    }
  },
  methods:{
    
  },
  created () {
  },
  mounted(){
    
  }
}
</script>
<style scoped>

</style>

